import { getAuth } from 'firebase/auth';
import BaseService from './base.service';

const baseService = new BaseService('massiveUserLoad', process.env.VUE_APP_SCHOOL_API_URL);

async function getFirebaseAuthHeaders(): Promise<Record<string, string>> {
  const auth = getAuth();
  if (!auth.currentUser) {
    return {};
  }

  const token = await auth.currentUser.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

function getParams(
  schoolId: number,
  excelFormat: string,
  forceChangeSchool: boolean,
  usersHaveDNI: boolean,
  disableOldData: boolean,
): string {
  return `?schoolId=${schoolId}&excelFormat=${excelFormat}&forceChangeSchool=${forceChangeSchool}&usersHaveDNI=${usersHaveDNI}&disableOldData=${disableOldData}`;
}

export default {
  loadDirectivesTeachersAndStudents: async (
    schoolId: number,
    excelFormat: string,
    forceChangeSchool: boolean,
    file: any,
    usersHaveDNI: boolean,
    disableOldData: boolean,
  ): Promise<any> => {
    const params = getParams(
      schoolId,
      excelFormat,
      forceChangeSchool,
      usersHaveDNI,
      disableOldData,
    );
    const headers = await getFirebaseAuthHeaders();
    return baseService.form(`/loadDirectivesTeachersAndStudents${params}`, file, headers);
  },
  startMassiveUpload: async (
    schoolId: number,
    excelFormat: string,
    forceChangeSchool: boolean,
    file: any,
    usersHaveDNI: boolean,
    disableOldData: boolean,
  ): Promise<any> => {
    const params = getParams(
      schoolId,
      excelFormat,
      forceChangeSchool,
      usersHaveDNI,
      disableOldData,
    );
    const headers = await getFirebaseAuthHeaders();
    return baseService.form(`/start${params}`, file, headers);
  },
  getProgress: async (jobId: string): Promise<any> => {
    const headers = await getFirebaseAuthHeaders();
    return baseService.get(`progress/${jobId}`, { headers });
  },
};
